import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false // NOSONAR
})
export class DialogComponent {

  message: string = "Are you sure?"
  pdfLinks: any;
  errorExists;
  title: string;
  // confirmButtonText = "Yes"
  closeButtonText = "Back"
  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly dialogRef: MatDialogRef<DialogComponent>) {
    if (data) {
      this.title = data.title;
      this.message = data.message || this.message;
      this.pdfLinks = data.pdfLinks;
      this.errorExists = data.errorExists ? data.errorExists : [];
      if (data.buttonText) {
        this.closeButtonText = data.buttonText.cancel || this.closeButtonText;
      }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }


}
